import { IGameData, Place } from 'js/bubbleCore/types';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { BubbleFactory, regularColors } from 'js/bubbleCore/bubbles/BubbleFactory';
import { getAngle, IPoint } from 'framework/utils/math-utils';
import {
  IEvent,
  createBubbleUpdatedEvent,
  createShooterUpdatedEvent,
} from 'js/bubbleCore/events';
import { transferBubble } from 'js/bubbleCore/handlers/transferBubble';
import { getAvailableColors } from 'js/bubbleCore/utils/getAvailableColors';

export function shoot(
  data: IGameData,
  factory: BubbleFactory,
  targetPoint: IPoint,
  events: IEvent[] = []
): IEvent[] {
  const shooterData = data.shooter;
  const bubble = shooterData.bubblesQueue.shift() as Bubble;
  shooterData.bubblesQueue.push(factory.createRegular(0, 0, getAvailableColors(data)));
  prepareBubbleToShoot(data, bubble, targetPoint);

  events.push(
    createBubbleUpdatedEvent(bubble),
    createShooterUpdatedEvent(shooterData),
  );
  transferBubble(bubble, data, Place.ShootingSpace, events);

  return events;
}


export function prepareBubbleToShoot(data: IGameData, bubble: Bubble, targetPoint: IPoint): Bubble {
  const shooterData = data.shooter;
  const angleBetween = getAngle(shooterData.position, targetPoint);
  bubble.hexSpaceX = shooterData.position.x;
  bubble.hexSpaceY = shooterData.position.y;
  bubble.velX = Math.cos(angleBetween) * shooterData.bubbleSpeed;
  bubble.velY = Math.sin(angleBetween) * shooterData.bubbleSpeed;
  return bubble;
}